@if (video$ | async; as video) {
  @if (showThumbnail || !allowPlayback) {
    <div
      class="thumbnail w-100 d-flex align-items-center justify-content-center"
      [style.background-image]="'url(' + (video.ThumbNail | contentImage: '7') + ')'"
    >
      @if (allowPlayback) {
        <button class="btn btn-link p-0 border-0 w-100 h-100" type="button" aria-label="Play" (click)="playVideo()">
          <div class="play-icon">
            <i class="material-symbols-outlined text-black play-icon-arrow">play_arrow</i>
          </div>
        </button>
      }
    </div>
  } @else {
    <div class="w-100 video-container bg-black">
      @switch (video.ProviderId) {
        @case (provider.Boxcast) {
          <fgbcl-boxcast-player [streamKey]="video.VideoKey"></fgbcl-boxcast-player>
        }
        @case (provider.YouTube) {
          <fgbcl-youtube-player [streamKey]="video.VideoKey"></fgbcl-youtube-player>
        }
        @case (provider.Vimeo) {
          <fgbcl-vimeo-player [streamKey]="video.VideoKey"></fgbcl-vimeo-player>
        }
        @case (provider.Streamable) {
          <fgbcl-streamable-player [streamKey]="video.VideoKey"></fgbcl-streamable-player>
        }
        @case (provider.Twitch) {
          <fgbcl-twitch-player [streamKey]="video.VideoKey"></fgbcl-twitch-player>
        }
        @case (provider.StreamAMG) {
          <fgbcl-stream-amg-player [streamKey]="video.VideoKey"></fgbcl-stream-amg-player>
        }
      }
    </div>
  }
}
